//api.mapbox.com/styles/v1/{username}/{style_id}/static/{overlay}/{lon},{lat},{zoom},{bearing},{pitch}|{bbox}|{auto}/{width}x{height}{@2x}

import React from 'react'
import { mapConfig } from './map-config'
import { getSystemTheme, useTheme } from './app-theme'
import { debounce } from './debounce'

export const StaticMap: React.FC<{
  lon: number
  lat: number
  zoom: number
  style: React.CSSProperties
  className?: string
}> = ({ lon, lat, zoom, style, className }) => {
  const [devicePixelRatio, setDevicePixelRatio] = React.useState<number | undefined>(1)
  React.useEffect(() => {
    setDevicePixelRatio(window.devicePixelRatio || 1)
  }, [])

  const [screenSize, setScreenSize] = React.useState<{ width: number; height: number } | null>(null)
  React.useEffect(() => {
    const handleResize = async () => {
      setScreenSize({ width: window.innerWidth, height: window.innerHeight })
    }
    const debouncedHandleResize = debounce(handleResize, 100)
    window.addEventListener('resize', debouncedHandleResize)
    debouncedHandleResize()
    return () => window.removeEventListener('resize', debouncedHandleResize)
  }, [])

  const theme = useTheme()
  const resolvedTheme = React.useMemo(() => {
    if (theme === 'system' || !theme) {
      return getSystemTheme()
    }
    return theme
  }, [theme])
  const styeId = React.useMemo(() => {
    return resolvedTheme === 'light' ? mapConfig.lightStyleId : mapConfig.darkStyleId
  }, [resolvedTheme])

  const url = React.useMemo(() => {
    if (!screenSize) return null
    if (!devicePixelRatio) return null
    const width = Math.min(screenSize.width, 1280)
    const height = Math.min(screenSize.height, 1280)
    return `https://api.mapbox.com/styles/v1/${mapConfig.account}/${styeId}/static/${lon},${lat},${zoom}/${width}x${height}@${devicePixelRatio}x?access_token=${process.env.NEXT_PUBLIC_MAPBOX_TOKEN}`
  }, [styeId, lon, lat, zoom, screenSize, devicePixelRatio])

  return <>{url && <img src={url} alt="Map" className={className} style={style} />}</>
}
